export const thumbnailHeight = 250;
export const thumbnailPadding = 55;
export const thumbnailContainerHeight = 700;
export const thumbnailContainerWidth = 300;
export const documentContainerHeight = 700;